import options from './component';


export default {
    selector: "dtEmulatorCellularStatus",
    options
}